import Axios from "axios";
import Instance from '../instance';
import WixConfig from '../../config/wix';

/**
 * -------------------------------------
 * GET API request.
 * -------------------------------------
 * 
 * @param path
 * @param data
 * 
 */

const GetRequest = (path: string, data = {}) => {
    /**
    *--------------------------------------------------------------------------
    * Generating URL
    *--------------------------------------------------------------------------
    * URL = Base URL + Path + Query parameters
    *--------------------------------------------------------------------------
    *
    */

    let baseUrl = WixConfig.backendApiBaseUrl;
    let queryParameters = Object.keys(data)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
        .join('&');
    queryParameters = queryParameters ? '?' + queryParameters : queryParameters;
    let url = baseUrl + path + queryParameters;

    /**
    *--------------------------------------------------------------------------
    * Get instance
    *--------------------------------------------------------------------------
    * Assumed that instance is appended in query param by Wix.
    *--------------------------------------------------------------------------
    * 
    */

    let instance = Instance.get();

    /**
    *--------------------------------------------------------------------------
    * Preparing headers
    *--------------------------------------------------------------------------
    * 
    */

    const headers = {
        accept: 'application/json',
        'Authorization': instance
    };

    /**
    *--------------------------------------------------------------------------
    * Send request
    *--------------------------------------------------------------------------
    * Send a GET request and return a promise that will resolve to JSON
    * response (error or success).
    *--------------------------------------------------------------------------
    * 
    */

    return new Promise((resolve, reject) => {
        Axios.get(
            url,
            { headers: headers }
        )
            .then((responseJSON) => resolve(responseJSON.data))
            .catch((error) => reject(error.response?.data))
    });
}

export default GetRequest;
